import { Fragment, type ReactNode, useSyncExternalStore } from "react";
import { getTheme, subscribeTheme } from "../../../lib/theme.js";

const serverTheme = () => "dark" as const;

/**
 * Rebuilds everything under it when the theme changes.
 *
 * A canvas cannot take a `var()`, so `chartPalette.readPalette` resolves the
 * tokens to rgba at mount and every lightweight-charts pane holds that
 * snapshot until it is torn down. Keying on the theme is what tears it down.
 *
 * Only wrap canvas charts. Recharts resolves `var()` natively and repaints on
 * its own; remounting an SVG pane would throw away its animation state for
 * nothing.
 */
export function ThemeScope({ children }: { children: ReactNode }) {
  const theme = useSyncExternalStore(subscribeTheme, getTheme, serverTheme);
  return <Fragment key={theme}>{children}</Fragment>;
}
